import { render, staticRenderFns } from "./DeliverableListCoordinators.vue?vue&type=template&id=e5c847e4&"
import script from "./DeliverableListCoordinators.vue?vue&type=script&lang=js&"
export * from "./DeliverableListCoordinators.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports